import React, { Component } from "react";
import moment from "moment";

import { scheduleResellerRateUpdate } from "../../../libs/functions";

import Swal from "sweetalert2";
import Util from "../../../libs/util";
import DatePicker from "react-datepicker";

const PercentTextInput = (props) => {
	return (
		<div className="uk-inline uk-width-1-1">
			<span
				className={`uk-form-icon uk-form-icon-flip`}
				uk-icon="icon: fa-solid-percent; ratio: 0.6"
			/>
			<input className="uk-input" {...props} />
		</div>
	);
};

const FixedTextInput = (props) => {
	return (
		<div className="uk-inline uk-width-1-1">
			<span
				className={`uk-form-icon`}
				uk-icon="icon: fa-solid-dollar-sign; ratio: 0.6"
			/>
			<input className="uk-input" {...props} />
		</div>
	);
};

class ScheduleRateUpdateModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			scheduleRates: {},
			effectiveDate: undefined,
		};

		this.scheduleRateUpdateModal = React.createRef();
		this.scheduleRateUpdateForm = React.createRef();
	}

	renderRateInputs = (gateway, type, region) => {
		return (
			<div className="uk-flex">
				<div className="uk-margin-small-right">
					<PercentTextInput
						name={`${gateway}-${type}-${region}-percent`}
						type="number"
						placeholder="Percent"
						onChange={(e) =>
							this.updateScheduleRates({
								type,
								region,
								isPercent: true,
								value: e.target.value,
							})
						}
					/>
				</div>
				<div className="uk-margin-small-left">
					<FixedTextInput
						name={`${gateway}-${type}-${region}-fixed`}
						type="number"
						placeholder="Fixed"
						onChange={(e) =>
							this.updateScheduleRates({
								type,
								region,
								isPercent: false,
								value: e.target.value,
							})
						}
					/>
				</div>
			</div>
		);
	};

	renderRateFields = (gateway, MDRTypes) => {
		return Object.keys(MDRTypes).map((type) => {
			return (
				<tr key={`new-${gateway}-${type}`}>
					<td className="uk-width-1-3">
						<img
							className="uk-img"
							src={`data:image/*;base64,${MDRTypes[type].image}`}
							width="35"
						/>
						<span className="uk-margin-small-left">{MDRTypes[type].label}</span>
					</td>
					<td className="uk-width-1-4">
						{this.renderRateInputs(gateway, type, "local")}
					</td>
					<td className="uk-width-1-4">
						{this.renderRateInputs(gateway, type, "overseas")}
					</td>
				</tr>
			);
		});
	};

	updateScheduleRates = (payload) => {
		const { scheduleRates: curScheduleRates } = this.state;
		const { type, region, isPercent, value } = payload;

		if (value > 0) {
			if (!curScheduleRates[type]) curScheduleRates[type] = {};
			if (!curScheduleRates[type][region]) curScheduleRates[type][region] = {};
			curScheduleRates[type][region][isPercent ? "percent" : "fixed"] =
				Number(value);
		} else {
			delete curScheduleRates[type][region][isPercent ? "percent" : "fixed"];
			if (Object.keys(curScheduleRates[type][region]).length === 0)
				delete curScheduleRates[type][region];
			if (Object.keys(curScheduleRates[type]).length === 0)
				delete curScheduleRates[type];
		}

		this.setState({ scheduleRates: curScheduleRates });
	};

	scheduleRateUpdate = () => {
		const { scheduleRates, effectiveDate } = this.state;
		const {
			payload: { reseller, gateway, currency },
		} = this.props;

		if (effectiveDate && Object.keys(scheduleRates).length > 0) {
			Swal.fire({
				title: "Scheduling Rate Update",
				onBeforeOpen: () => {
					Util.hideModal("schedule-reseller-rates");
					Swal.showLoading();
				},
				onOpen: async () => {
					try {
						const { status } = await scheduleResellerRateUpdate({
							reseller,
							paymentGateway: gateway.name,
							currency: currency.number,
							rates: scheduleRates,
							effectiveDate,
						});
						if (status === "success") {
							Swal.fire({
								icon: "success",
								title: "Rate Update Scheduled",
							}).then(async () => {
								this.scheduleRateUpdateForm.current.reset();
								this.setState({ scheduleRates: {}, effectiveDate: undefined });
								await this.props.refreshRates();
							});
						}
					} catch (err) {
						Swal.fire({
							icon: "error",
							title: `Unable to schedule rate update`,
							onClose: () => {},
						});
					}
				},
			});
		}
	};

	render() {
		const { effectiveDate } = this.state;
		const { payload } = this.props;
		const { gateway, currency, MDRTypes } = payload;

		const startDate = moment().add(1, "days").toDate();

		return (
			<div
				id="schedule-reseller-rates"
				className="uk-modal-container"
				uk-modal="stack: true; esc-close: false; bg-close:false;"
				ref={this.scheduleRateUpdateModal}
			>
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">
						Schedule rate update for {gateway?.label}
					</h2>
					<form ref={this.scheduleRateUpdateForm}>
						<div
							className={`uk-button uk-button-default action-btn uk-margin-right uk-active`}
							type="button"
						>
							<span className="uk-text-bold">{currency?.code}</span>
						</div>
						<DatePicker
							dateFormat="dd MMM yyyy"
							selected={effectiveDate}
							onChange={(date) => this.setState({ effectiveDate: date })}
							startDate={startDate}
							minDate={startDate}
							className={"uk-input uk-width-medium"}
							placeholderText="Effective Date"
						/>
						{Object.keys(payload).length > 0 && (
							<div className="uk-margin">
								<table className="uk-table uk-table-striped uk-table-middle uk-margin-remove-bottom">
									<thead>
										<tr>
											<th className="uk-width-1-3">Payment Type</th>
											<th className="uk-width-1-4">Local Card</th>
											<th className="uk-width-1-4">Overseas Card</th>
										</tr>
									</thead>
								</table>
								<div className="add-reseller-rates-table uk-overflow-auto">
									<table className="uk-table uk-table-striped uk-table-middle uk-margin-remove-top">
										<tbody>
											{this.renderRateFields(gateway?.name, MDRTypes)}
										</tbody>
									</table>
								</div>
							</div>
						)}
					</form>
					<p className="uk-text-right">
						<button
							className="uk-button uk-button-default uk-modal-close"
							type="button"
						>
							Cancel
						</button>
						<button
							className="uk-button uk-button-primary"
							onClick={() => this.scheduleRateUpdate()}
						>
							Schedule
						</button>
					</p>
				</div>
			</div>
		);
	}
}

export default ScheduleRateUpdateModal;
